import { useState, useEffect } from 'react';
import { Box, Button, Divider, Drawer, IconButton, List, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IconArrowRight, IconMenu2, IconX } from '@tabler/icons-react';
import Logo from 'ui-component/Logo';
import ThemeButton from 'ui-component/ThemeButton';
import ProfileSection from 'layout/MainLayout/Header/ProfileSection';
const links = [
  ['模型与价格', '/models'],
  ['快速接入', '/#integration'],
  ['平台能力', '/#capabilities'],
  ['开发文档', '/about']
];
export default function Header() {
  const { pathname } = useLocation();
  const user = useSelector((state) => state.account.user);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return (
    <>
      <Box component={Link} to="/" aria-label="返回主页" sx={{ textDecoration: 'none', flexShrink: 0 }}>
        <Logo tagline />
      </Box>
      <Stack
        component="nav"
        aria-label="网站导航"
        direction="row"
        gap={{ md: 1, lg: 2 }}
        sx={{ display: { xs: 'none', md: 'flex' }, mx: 'auto' }}
      >
        {links.map(([label, url]) => (
          <Button
            key={url}
            component={Link}
            to={url}
            color={pathname === url ? 'primary' : 'inherit'}
            sx={{ fontSize: 13, fontWeight: 500, px: 1 }}
          >
            {label}
          </Button>
        ))}
      </Stack>
      <Stack direction="row" alignItems="center" gap={{ xs: 1, sm: 1.5 }} sx={{ ml: { xs: 'auto', md: 0 } }}>
        <ThemeButton />
        {user ? (
          <>
            <Button component={Link} to="/panel" variant="contained" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>
              控制台
            </Button>
            <ProfileSection />
          </>
        ) : (
          <>
            <Button component={Link} to="/login" variant="outlined" color="inherit" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>
              登录
            </Button>
            <Button
              component={Link}
              to="/register"
              variant="contained"
              endIcon={<IconArrowRight size={15} />}
              sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
            >
              开始使用
            </Button>
          </>
        )}
        <IconButton aria-label="打开主页导航" aria-expanded={open} sx={{ display: { md: 'none' } }} onClick={() => setOpen(true)}>
          <IconMenu2 size={21} />
        </IconButton>
      </Stack>
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)} PaperProps={{ sx: { width: 320, maxWidth: '100vw' } }}>
        <Box component="nav" aria-label="移动网站导航" sx={{ p: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography fontWeight={600}>网站导航</Typography>
            <IconButton aria-label="关闭主页导航" onClick={() => setOpen(false)}>
              <IconX size={20} />
            </IconButton>
          </Stack>
          <List>
            {links.map(([label, url]) => (
              <ListItemButton component={Link} to={url} key={url} onClick={() => setOpen(false)} sx={{ minHeight: 48 }}>
                <ListItemText primary={label} />
              </ListItemButton>
            ))}
          </List>
          <Divider sx={{ my: 2 }} />
          {user ? (
            <Button fullWidth component={Link} to="/panel" variant="contained" onClick={() => setOpen(false)}>
              进入控制台
            </Button>
          ) : (
            <Stack gap={1.5}>
              <Button fullWidth component={Link} to="/login" variant="outlined" onClick={() => setOpen(false)}>
                登录
              </Button>
              <Button fullWidth component={Link} to="/register" variant="contained" onClick={() => setOpen(false)}>
                开始使用
              </Button>
            </Stack>
          )}
        </Box>
      </Drawer>
    </>
  );
}
